import React from 'react';
import Button from '@material-ui/core/Button';
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import ListItem from "@material-ui/core/ListItem";
import _, { omit, pick, round, slice } from 'lodash';
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormControl, FormLabel, FormHelperText, Paper, Chip, Card, CardHeader, CardMedia, CardContent, CardActions, Avatar } from '@material-ui/core';
import { actions } from "../reducers/app";
import { useDispatch, useSelector } from "react-redux";
import PF from "../_Services/publicFunction";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Qs from "qs";
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Bar } from 'react-chartjs-2';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { VolumeUp } from '@material-ui/icons';
import useSound from 'use-sound';
import clickdown from '../sounds/clickdown.wav';
import clickup from '../sounds/clickdown.wav';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';
import { useSnackbar } from "notistack";

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 8,
        // borderRadius: 5,
    },
    colorPrimary: {
        //backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        // borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(3),
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0),
    },
    root: {
        color: theme.palette.type === "dark" ? "#1a90ff" : "#3f51b5"
    },
    submitButton: {
        width: "100%", background: '#2E3B55', fontWeight: "bold",
        "&:hover": {
            background: '#fffff',
            // color:'#2E3B55'
        }
    },

}));

const Questionaire68th = props => {
    // const [progress, setProgress] = React.useState(0);
    const [numerator, setNumerator] = React.useState(0)
    const [denominator, setDenominator] = React.useState(18)
    const intl = useIntl();

    const initialRender = React.useRef(true);

    const { handleNext, setActiveStep } = props;
    const dispatch = useDispatch();
    const { UserInfo } = useSelector(state => ({
        UserInfo: state.app.UserInfo,
    }));
    const [playActive] = useSound(
        clickdown,
        { volume: 0.25 }
    );
    const [playOn] = useSound(
        clickup,
        { volume: 0.25 }
    );
    const classes = useStyles();
    const [uploadFormat, setUpload] = React.useState({
        0: { BarCodeStr: "", QuestionNo: 68, Category: "填寫前說明", titleNo: "", Title: "說明：本量表所列舉的問題是為協助您瞭解您的心情狀況，請您仔細回想在一星期中，這些問題發生幾天，然後圈選一個您認為最能代表您感覺的答案。『沒有或極少』1天以下/週，『有時候』1~2天/週，『時常』3~4天/週，『常常或總是』5~7天/週", SelectTitle: "", Answer: "", Other: "" },
        1: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 1, Title: "我常常覺得想哭", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        2: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 2, Title: "我覺得心情不好", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        3: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 3, Title: "我覺得比以前容易發脾氣", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        4: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 4, Title: "我睡不好", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        5: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 5, Title: "我覺得不想吃東西", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        6: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 6, Title: "我覺得胸口悶悶的", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        7: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 7, Title: "我覺得不輕鬆、不舒服", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        8: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 8, Title: "我覺得身體疲勞虛弱無力", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        9: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 9, Title: "我覺得很煩", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        10: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 10, Title: "我覺得記憶力不好", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        11: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 11, Title: "我覺得做事時無法專心", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        12: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 12, Title: "我覺得想事情或做事時比平常要緩慢", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        13: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 13, Title: "我覺得比以前沒信心", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        14: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 14, Title: "我覺得比較會往壞處想", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        15: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 15, Title: "我覺得想不開，甚至想死", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        16: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 16, Title: "我覺得對什麼事都失去興趣", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        17: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 17, Title: "我覺得身體不舒服", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        18: { BarCodeStr: "", QuestionNo: 68, Category: "一、心情評量", titleNo: 18, Title: "我覺得自己很沒用", SelectTitle: "○沒有或極少  ○有時候  ○時常  ○常常或總是", Answer: "", Other: "" },
        19: { BarCodeStr: "", QuestionNo: 68, Category: "二、計分方式", titleNo: 1, Title: "『沒有或極少』0分；『有時候』1分；『時常』2分；『常常或總是』3分", SelectTitle: "您的分數：＿分", Answer: "", Other: "" },
        20: { BarCodeStr: "", QuestionNo: 68, Category: "二、計分方式", titleNo: 2, Title: "8 分以下---情緒穩定", SelectTitle: "", Answer: "", Other: "" },
        21: { BarCodeStr: "", QuestionNo: 68, Category: "二、計分方式", titleNo: 3, Title: "9~14分---情緒較不穩定、多注意情緒變化，多給自己關心", SelectTitle: "", Answer: "", Other: "" },
        22: { BarCodeStr: "", QuestionNo: 68, Category: "二、計分方式", titleNo: 4, Title: "15~18分---壓力負荷已到極點，需要找朋友交談、舒緩情緒", SelectTitle: "", Answer: "", Other: "" },
        23: { BarCodeStr: "", QuestionNo: 68, Category: "二、計分方式", titleNo: 5, Title: "19分以上---必須找專業醫療單位協助", SelectTitle: "", Answer: "", Other: "" },
    });
    const [scores, setScores] = React.useState(0);
    const [done, setDone] = React.useState(false);
    React.useEffect(() => {
        //寫入BarCodeStr
        let obj = Object.values(uploadFormat).reduce((o, { }, index) => {
            o[index] = { BarCodeStr: UserInfo.BarCodeStr }
            return o
        }, {})
        let newitem = _.merge(uploadFormat, obj);
        // console.log(newitem)
        setUpload(prevState => newitem);

    }, [])
    const { enqueueSnackbar } = useSnackbar();



    const validator = () => {
        const form = formRef.current; //參數1
        if (form.checkValidity()) {
            // console.log("全部通過")
            //若驗證通過，刪除錯誤提示
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (Object.keys(uploadFormat).includes(element.name)) {
                    setUpload(prevState => ({
                        ...prevState,
                        [element.name]: omit(prevState[element.name], ["error", "helperText"])
                    }));
                }

            }
            return true;
        } else {
            // const form = formRef.current;
            // console.log("還沒通過")
            alert(intl.formatMessage({ id: "尚有問題未完成" }));
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
                    console.log(element.validationMessage, element.name);
                    console.log(element.value)
                    // console.log(element.value, element.validationMessage, element.name, element.tagName)
                    if (Object.keys(uploadFormat).includes(element.name)) {
                        setUpload(prevState => ({
                            ...prevState,
                            [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
                        }));
                    }


                } else {//驗證通過，自訂訊息
                    //有在settingObj的
                    console.log("Pass", element.value, element.validationMessage, element.name, element.tagName)
                    if (Object.keys(uploadFormat).includes(element.name)) {
                        setUpload(prevState => ({
                            ...prevState,
                            [element.name]: omit(prevState[element.name], ["error", "helperText"])
                        }));
                    }

                }
            }
            return false;
        }
    }
    const handleSubmit = e => {
        e.preventDefault();
        //setError(!error);
        if (validator()) {
            dispatch(actions.TAB_EDIT({ editing: true, key: 68 }))
            PF.instance({
                method: "post",
                url: PF.url + "/Questionaire/Insert",
                data: Qs.stringify({ list: Object.values(uploadFormat) }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    console.log(response.data)
                    const { TotalRecord, ErrorMessage } = response.data
                    if (TotalRecord <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar(intl.formatMessage({ id: "update fail" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                        setDone(true);
                        enqueueSnackbar(intl.formatMessage({ id: "update success" }), { variant: "success", style: { whiteSpace: 'pre-line' } });
                    }
                })

        }
    }
    const [obj, setObj] = React.useState({});
    const handleRadioChange = e => {
        // e.prevetDefault();
        if (!done) {
            let transfer = {
                "沒有或極少": 0,
                "有時候": 1,
                "時常": 2,
                "常常或總是": 3,
            }
            const { name, value } = e.target;
            // console.log(name, value)
            // setValue(value);
            setUpload(prevState => ({
                ...prevState,
                [name]: { ...prevState[name], BarCodeStr: UserInfo.BarCodeStr, Answer: value }
            }))
            //ProgressBar

            setObj(prev => ({
                ...prev,
                [name]: transfer[value]
            }))
            if (uploadFormat[name].Answer === "") {
                // setProgress(prev => prev < 99.9 ? (prev + 5.55) : prev)
                setNumerator(prev => prev + 1)
            }
        }
    }
    const formRef = React.createRef();
    React.useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false
        } else {
            //let x = Object.values(uploadFormat).slice(1,19).reduce((a,{Answer})=>a+ (transfer[Answer]),0);
            let y = Object.values(obj);
            //console.log(x)
            // console.log(y)
            let z = y.reduce((a, b) => a + (b === undefined ? 0 : b), 0);
            // console.log(z)
            setScores(z)
            //寫入分數
            setUpload(prevState => ({
                ...prevState,
                19: { ...prevState[19], Other: z },
            }));
        }

    }, [obj])

    return (
        <Paper>
            <h1 style={{ textAlign: "center" }}><FormattedMessage id={"心情量表"} /></h1>
            <form onSubmit={handleSubmit} ref={formRef} noValidate>
                <fieldset>
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"填寫前說明"} /></Typography></legend>
                    <Typography><FormattedMessage id={uploadFormat[0].Title} /></Typography>
                </fieldset>
                <fieldset>
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"心情量表"} /></Typography></legend>
                    {Object.values(uploadFormat).slice(1, 19).map((item, index) => {
                        return (
                            <FormControl component="fieldset" error={item.error} required className={classes.formControl} key={index}>
                                <FormLabel component="legend" className={classes.root}>{item.titleNo + "."}<FormattedMessage id={item.Title} /></FormLabel>
                                <RadioGroup name={item.titleNo} value={item.Answer} onChange={handleRadioChange} style={{ display: "block" }}>
                                    {item.SelectTitle.replaceAll("○", "").split("  ").map(pro => {
                                        return (
                                            <FormControlLabel value={pro} control={<Radio color="primary" required />} label={<FormattedMessage id={pro} />} onMouseDown={() => { playActive() }} />)
                                    })}
                                </RadioGroup>
                                <FormHelperText>{item.error ? <FormattedMessage id={item.helperText} /> : null}</FormHelperText>
                            </FormControl>)
                    })}
                </fieldset>
                <fieldset style={{ marginBottom: "50px" }} >
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"計分方式"} /></Typography></legend>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <Typography><FormattedMessage id={uploadFormat[19].Title} /></Typography>
                            <Typography variant={_.inRange(scores, 0, 8.9) ? "h6" : "body1"} style={{ color: _.inRange(scores, 0, 8.9) ? "rgba(75, 192, 192)" : "" }}><FormattedMessage id={uploadFormat[20].Title} /></Typography>
                            <Typography variant={_.inRange(scores, 9, 14.9) ? "h6" : "body1"} style={{ color: _.inRange(scores, 9, 14.9) ? "rgba(255, 206, 86)" : "" }}><FormattedMessage id={uploadFormat[21].Title} /></Typography>
                            <Typography variant={_.inRange(scores, 15, 18.9) ? "h6" : "body1"} style={{ color: _.inRange(scores, 15, 18.9) ? "rgba(255, 159, 64)" : "" }}><FormattedMessage id={uploadFormat[22].Title} /></Typography>
                            <Typography variant={_.inRange(scores, 19, 55) ? "h6" : "body1"} style={{ color: _.inRange(scores, 19, 55) ? "rgba(255, 99, 132)" : "" }}><FormattedMessage id={uploadFormat[23].Title} /></Typography>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <HorizontalBarChart score={scores} label={intl.formatMessage({ id: "心情量表" })} />
                        </GridItem>
                    </GridContainer>
                </fieldset>
                <div style={{ width: '100%', bottom: !done ? "36px" : "0px", position: "fixed", }}>
                    <BorderLinearProgress variant="determinate" value={(numerator / denominator) * 100} />
                </div><br /><br />
                {!done ? (<div style={{ top: 'auto', bottom: 0, position: "fixed", width: "100%" }}>
                    <Button variant="contained" color="primary" type="submit" onClick={handleSubmit} className={classes.submitButton}><FormattedMessage id={"app.Submit"} /></Button>
                </div>) : null}
            </form>
        </Paper>
    )



}

export default Questionaire68th



const HorizontalBarChart = React.memo((props) => {
    const { score, label } = props;
    console.log("render")
    const getColor = s => {
        switch (true) {
            case (s <= 8):
                return finColor["green"]
            case (s <= 14):
                return finColor["yello"]
            case (s <= 18):
                return finColor["orange"]
            case (s >= 19):
                return finColor["red"]
            default:
                console.log("none");
                break;
        }
    }
    const color = {
        red: "rgba(255, 99, 132,0.2)",
        orange: "rgba(255, 159, 64,0.2)",
        yello: "rgba(255, 206, 86,0.2)",
        green: "rgba(75, 192, 192,0.2)"
    }
    const finColor = {
        red: "rgba(255, 99, 132)",
        orange: "rgba(255, 159, 64)",
        yello: "rgba(255, 206, 86)",
        green: "rgba(75, 192, 192)"
    }

    let data = {
        labels: [score],
        datasets: [
            {
                label: label,
                data: [score],
                backgroundColor: [
                    getColor(score)
                ],

            },
        ],
    };

    const options = {
        indexAxis: 'y',
        // Elements options apply to all of the options unless overridden in a dataset
        // In this case, we are setting the border of each horizontal bar to be 2px wide
        elements: {
            bar: {
                // borderWidth: 2,
            },
        },
        scales: {

            x: {
                max: 55,
                min: 0,
                ticks: {
                    beginAtZero: true,  //整數
                    stepSize: 5,

                },

            },
            y: {

                ticks: {
                    font: {
                        size: 40,
                    }
                }

            }
        },
        responsive: false,
        plugins: {
            legend: {
                position: 'top',
            },
            // title: {
            //     display: true,
            //     text: '累計得分',
            // },
        },
    };


    return (
        <Bar data={data} options={options} />
    )
});
